<template>
  <div class="t-content">
    <!-- <a-button class="app-btn info-btn mb-5" @click="add">添加新资料</a-button>
    <a-button v-if="documentList && documentList.length > 0" class="app-btn info-btn mb-5 ml-5" @click="updateSort">
      修改排序
    </a-button> -->
    <!-- <a-button class="app-btn info-btn mb-5 ml-5" @click="addFromModal">从模版库添加</a-button> -->
    <!-- <a-button class="app-btn info-btn mb-5 ml-5" @click="copyModal">复制</a-button> -->
    <!-- <div class="ad-table">
      <div class="ad-title">
        <div class="hadder">
          <div class="h-t" style="width: 30%; border-right: 1px solid #dfdfdf">资料名称</div>
          <div class="h-t" style="width: 70%">基础资料</div>
        </div>
        <div v-for="(item, index) in documentList" :key="index" class="content" style="border-left: 1px solid #dfdfdf">
          <div class="h-c" style="width: 30%">
            <div class="h-c-d" style="width: 100%">
              <div style="display: flex; flex-direction: column; width: 100%">
                <div style="text-align: center">{{ item.documentName }}</div>
                <div style="text-align: center">
                  <span style="margin-right: 20px; color: #df7163; cursor: pointer" @click="editData(item, index)">
                    编辑
                  </span>
                  <span style="color: #df7163; cursor: pointer" @click="removeData(index)">删除</span>
                </div>
              </div>
            </div>
          </div>
          <div class="h-c-1" style="width: 70%">
            <div>
              <div class="l-title">是否必填：</div>
              <div class="l-input">
                <a-select v-model="item.required" placeholder="请选择类型">
                  <a-select-option :value="true">必填</a-select-option>
                  <a-select-option :value="false">非必填</a-select-option>
                </a-select>
              </div>
            </div>
            <div>
              <div class="l-title">资料分类：</div>
              <div class="l-input">
                <a-select v-model="item.documentType" placeholder="请选择">
                  <a-select-option :value="1">电子资料</a-select-option>
                  <a-select-option :value="2">纸质资料</a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <a-table
      :rowKey="
        (record, index) => {
          return index
        }
      "
      bordered
      :columns="tableColumns"
      :dataSource="documentList"
      @change="handleTableChange$qv"
      :pagination="false"
    >
      <!-- 操作列 -->
      <!-- <template slot="handler" slot-scope="text, row, index">
        <div class="flex gap-5 justify-center text-primary-500">
          <a-button type="link" size="small" @click="editData(row, index)">编辑</a-button>
          <a-button type="link" size="small" @click="removeData(row)">删除</a-button>
        </div>
      </template> -->
    </a-table>
    <a-modal :title="modal1.title" v-model="modal1.visible" @cancel="handleCancel" :width="800">
      <div class="detailView">
        <a-form class="form" :form="modal1.form" :colon="false">
          <a-form-item label="资料名称" required>
            <a-input
              v-decorator="[
                'documentName',
                {
                  rules: [{ required: true, message: '资料名称不能为空' }],
                },
              ]"
              placeholder="请输入资料名称"
            ></a-input>
          </a-form-item>
          <a-form-item label="图片示例">
            <PictureCardUpload
              v-decorator="['exampleUrl']"
              preview
              :itemWidth="150"
              :itemHeight="187"
            ></PictureCardUpload>
          </a-form-item>
          <a-form-item label="资料模版">
            <PictureCardUpload
              v-decorator="['templateUrl']"
              preview
              :tips="'点击上传'"
              :beforeUpload="beforeUpload"
              :itemWidth="198"
              :itemHeight="124"
            ></PictureCardUpload>
          </a-form-item>
          <a-form-item label="资料描述" :wrapperCol="{ style: 'width: 100%' }" required>
            <RichText
              v-decorator="['documentDescription', { rules: [{ required: true, message: '请输入资料描述' }] }]"
            ></RichText>
          </a-form-item>
        </a-form>
      </div>
      <template slot="footer">
        <a-button type="primary" @click="handleCancel" :disabled="formDcb">关闭</a-button>
        <a-button type="primary" @click="handleOk1" :disabled="formDcb">保存</a-button>
      </template>
    </a-modal>
    <a-modal title="修改排序" v-model="sortVisibleType" @ok="sortHandleOk" @cancel="handleCancelSort" :width="800">
      <div>
        <draggable v-model="documentList" chosenClass="chosen" forceFallback="true" group="people" animation="800">
          <transition-group>
            <div class="item" v-for="(item, index) in documentList" :key="index + 'material'">
              <div style="border-right: 1px solid #dffdfdf; width: 120px; text-align: center">{{ index + 1 }}</div>
              <div>
                {{ item.documentName }}
              </div>
            </div>
          </transition-group>
        </draggable>
      </div>
    </a-modal>
    <MaterialTemplate ref="materialTemplate"></MaterialTemplate>
    <CopyProductInfo ref="copyProductInfo"></CopyProductInfo>
  </div>
</template>

<script>
import RichText from '@/components/RichText'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import draggable from 'vuedraggable'
import MaterialTemplate from './MaterialTemplate1.vue'
import CopyProductInfo from './CopyProductInfo.vue'
export default {
  components: {
    PictureCardUpload,
    MaterialTemplate,
    draggable,
    CopyProductInfo,
    RichText,
  },
  props: {
    occupationId: {
      type: String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
    dataType: {
      type: String,
      default: '',
    },
    type: {
      type: Boolean,
      default: false,
    },
    productType: {
      type: Number,
      require: true,
    },
  },
  mixins: [toolMixin, queryViewMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '60px',
        align: 'center',
        customRender: (text, row, index) => {
          return <span> {index + 1} </span>
        },
      },
      {
        title: '资料名称',
        align: 'center',
        dataIndex: 'documentName',
      },
      {
        title: '是否必填',
        align: 'center',
        dataIndex: 'required',
        customRender: (text, row) => {
          return <span style="">{text ? '必填' : '非必填'}</span>
        },
      },
      {
        title: '资料分类',
        align: 'center',
        dataIndex: 'documentType',
        customRender: (text, row) => {
          return <span>{this.getStatus(text)}</span>
        },
      },
      // {
      //   title: '操作',
      //   width: '200px',
      //   align: 'center',
      //   dataIndex: 'detail',
      //   scopedSlots: {
      //     customRender: 'handler',
      //   },
      // },
    ]
    return {
      formDcb: false,
      tableColumns,
      modal1: {
        visible: false,
        edit: null,
        form: this.$form.createForm(this),
        title: '添加新资料',
        data: {},
      },
      documentList: [],
      oldList: [],
      sortVisibleType: false,
      documentId: '',
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    getStatus(text) {
      switch (text) {
        case 1:
          return '电子资料'
        case 2:
          return '纸质资料'
        default:
          return ''
      }
    },
    updateVisaType(n) {
      if (this.documentList && this.documentList.length > 0) {
        if (n) {
          this.documentList.forEach(e => {
            e.documentType = n
          })
        } else {
          console.log('null')
        }
      }
    },
    removeData(index) {
      this.documentList.splice(index, 1)
    },
    updateSort() {
      if (this.documentList && this.documentList.length) {
        this.oldList = JSON.parse(JSON.stringify(this.documentList))
        this.sortVisibleType = true
      } else {
        this.$message.error('暂无数据！')
      }
    },
    async copyModal() {
      const id = await this.$refs.copyProductInfo.start()
      this.copyInit(id)
    },
    async addFromModal() {
      const rows = await this.$refs.materialTemplate.start({ productType: 1 })
      rows.forEach(e => {
        const obj = {
          documentId: null,
          productId: this.productId ? this.productId : '',
          occupationId: '0',
          type: 1,
          documentName: e.materialTemplateName,
          countryName: '',
          documentType: e.documentType,
          exampleUrl: e && e.exampleUrl ? e.exampleUrl : '',
          templateUrl: e && e.templateUrl ? e.templateUrl : '',
          documentDescription: e.documentDescription,
          required: e.required,
        }
        this.documentList.push(obj)
      })
    },
    handleCancel() {
      this.modal1.visible = false
      this.modal1.edit = null
      this.formDcb = false
    },
    handleCancelSort() {
      if (this.oldList && this.oldList.length > 0) {
        this.documentList = JSON.parse(JSON.stringify(this.oldList))
      }
      this.sortVisibleType = false
    },
    getList() {
      this.documentList.forEach(element => {
        element.occupationId = 0
      })
      return this.documentList
    },
    sortHandleOk() {
      this.sortVisibleType = false
    },
    handleOk1() {
      this.modal1.form.validateFields((errors, values) => {
        if (!errors) {
          const params = values
          if (this.modal1.edit === null) {
            if (this.documentList.some(v => v.documentName === params.documentName)) {
              return this.$message.error('名称不可重复添加！')
            }
            const obj = {
              documentId: null,
              productId: this.productId ? this.productId : '',
              occupationId: 0,
              documentName: params && params.documentName ? params.documentName : '',
              countryName: '',
              documentType: 1,
              type: 1,
              exampleUrl: params && params.exampleUrl ? params.exampleUrl : '',
              templateUrl: params && params.templateUrl ? params.templateUrl : '',
              documentDescription: params && params.documentDescription ? params.documentDescription : '',
              required: 0,
            }
            this.documentList.push(obj)
          } else {
            this.documentList[this.modal1.edit].documentDescription = params.documentDescription
            this.documentList[this.modal1.edit].exampleUrl = params && params.exampleUrl ? params.exampleUrl : ''
            this.documentList[this.modal1.edit].templateUrl = params && params.templateUrl ? params.templateUrl : ''
            this.documentList[this.modal1.edit].documentName = params.documentName
          }
          this.modal1.visible = false
          this.modal1.edit = null
          this.formDcb = false
        }
      })
    },
    editData(item, index) {
      this.$nextTick(() => {
        this.safeSetFieldsValue$t(this.modal1.form, { ...item })
      })
      this.modal1.edit = index

      this.modal1.visible = true
    },
    async init() {
      if (this.productId) {
        // 根据产品id 查询资料列表
        const res = await this.$axios.get(`/visa/admin/product/${this.productId}/document`)
        if (res.success) {
          this.documentList = res.data.filter(v => parseInt(v.type) === 1)
        }
      }
    },

    async copyInit(productId) {
      if (productId) {
        // 根据产品id 查询资料列表
        const res = await this.$axios.post('/visa/admin/productMaterial/queryMaterialListByProductId', {
          data: {
            productId,
          },
        })
        if (res.success) {
          this.documentList = res.data.filter(v => parseInt(v.type) === 1)
          this.documentList.forEach(element => {
            element.productId = this.productId
          })
        }
      }
    },
    async loadList() {
      // 转单产品
      if (this.productType === 1) {
        const res = await this.$axios.post('/visa/admin/productMaterial/queryMaterialListByMaterialTypeId', {
          data: {
            occupationId: this.occupationId,
          },
        })
        res.data.forEach(element => {
          element['check'] = false
        })
        this.documentList = res.data
      }
      if (this.productType === 3) {
        const res = await this.$axios.post('/visa/admin/productMaterial/queryMaterialListByProductId', {
          data: {
            productId: this.productId,
          },
        })
        res.data.forEach(element => {
          element['check'] = false
        })
        this.documentList = res.data
      }
    },
    async add() {
      this.modal1.form.resetFields()
      this.modal1.visible = true
    },
    remove(row, index) {
      if (row.documentId) {
        this.$confirm({
          title: '提示',
          content: '确定删除?',
          onOk: () => {
            this.$axios
              .post('/visa/admin/productMaterial/deleteByMaterialId', {
                data: {
                  documentId: row.documentId,
                },
              })
              .then(res => {
                if (res.success) {
                  this.loadList()
                  this.$message.success('操作成功!')
                } else {
                  // 删除失败提示
                }
              })
          },
        })
      } else {
        this.documentList.splice(index, 1)
      }
    },
    beforeUpload(file) {
      if (!file.name.toLowerCase().match(/\.(doc|docx|pdf|xls|xlsx|jpg|png|bmp)$/)) {
        this.$message.error('请上传doc、docx、xls、xlsx、pdf文件或jpg、png、bmp图片')
        return false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.h-c-d {
  flex-shrink: 0;
  border: 1px solid #dfdfdf;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .h-c-item {
    height: 20%;
    line-height: 40px;
    text-align: center;
    border-bottom: 1px solid #dfdfdf;
    width: 100%;
    &:last-child {
      border-bottom: none;
    }
  }
}
.t-content {
  width: 100%;
  .ad-table {
    width: 100%;
    min-height: 200px;
    max-height: 500px;
    border: 1px solid #dfdfdf;
    overflow: auto;
    .ad-title {
      width: 100%;
      display: flex;
      flex-direction: column;
      .hadder {
        width: 100%;
        display: flex;
        flex-direction: row;
        .h-t {
          height: 50px;
          background: #fd7163;
          color: #fff;
          line-height: 50px;
          text-align: center;
        }
      }
      .content {
        display: flex;
        flex-direction: row;
        .h-c {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .h-c-d {
            border: 1px solid #dfdfdf;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .h-c-1 {
          display: flex;
          flex-direction: column;
          div {
            height: 42px;
            display: flex;
            .l-title {
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #dfdfdf;
              width: 120px;
            }
            .l-input {
              flex: 1;
              border: 1px solid #dfdfdf;
              text-align: center;
              padding: 4px 20px 0 20px;
            }
          }
        }
      }
    }
  }
}
/*被拖拽对象的样式*/
.item {
  display: -webkit-box;
  padding: 6px;
  background-color: #fdfdfd;
  border: solid 1px #eee;
  margin-bottom: 10px;
  cursor: move;
}
/*选中样式*/
.chosen {
  border: solid 1px #3089dc !important;
}
</style>
